import { useQuery } from '@tanstack/react-query';

import missionQueries from '@facilities/utils/missionQueryFactory';

const useFetchMissions = (facilityId: string) => useQuery(missionQueries.list(facilityId));

export default useFetchMissions;
